import css from './Single.module.scss'
import React, { RefObject, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Range } from 'react-input-range'
import classNames from 'classnames'

import { ITicket } from 'meta/backendControlled/structure'
import { Breakpoints } from 'meta/layout/breakpoints'
import { IMap, IMapSeat } from 'meta/map'
import { ICheckoutDetails, TicketSelectionType } from 'meta/pages/checkout'

import Automatic from 'components/Checkout/TicketSelection/Automatic'
import Filters from 'components/Checkout/TicketSelection/Filters'
import TicketSeatSelector from 'components/Checkout/TicketSelection/TicketSeatSelector'
import { GridColumn } from 'components/Layout/Grid'
import { useCheckoutDetails, useCheckoutTicketSelection } from 'hooks/useCheckout'

interface IProps {
  modalRef?: RefObject<HTMLElement>
  onSelectSeat: (seats: Array<IMapSeat>, typeTicketId?: number) => void
  ticketsData: ITicket[]
  showTitle?: boolean
}

const Single: React.FC<IProps> = (props) => {
  const { modalRef, onSelectSeat, ticketsData } = props

  const { typeTicketCollection, eventTicket, initialTypeTicketId, initialGroupId } =
    useCheckoutDetails() as ICheckoutDetails

  const ticketSelection = useCheckoutTicketSelection()

  const { t } = useTranslation()

  const automaticTicketSelection: boolean = ticketSelection?.type === TicketSelectionType.automatic

  const minPrice = Math.min(...ticketsData.map((x) => x.priceNumber))
  const maxPrice = Math.max(...ticketsData.map((x) => x.priceNumber))
  const priceRangeInitial: Range = { min: minPrice, max: maxPrice }
  const [priceRangeCurrent, setPriceRangeCurrent] = useState<Range>({
    min: minPrice,
    max: maxPrice,
  })

  if (
    eventTicket.groups &&
    eventTicket.groups.length > 0 &&
    initialTypeTicketId &&
    !ticketsData.map((x) => x.id).includes(initialTypeTicketId)
  ) {
    return null
  }

  if (initialGroupId) {
    return null
  }

  return (
    <GridColumn
      gridColumnStart={{ [Breakpoints.laptop]: 2, [Breakpoints.mobile]: 1 }}
      gridColumnEnd={{ [Breakpoints.laptop]: 16, [Breakpoints.mobile]: 17 }}
    >
      <div className={classNames(css.container)}>
        <h3>{t('checkout:single_tickets')}</h3>

        {ticketsData.length > 1 && automaticTicketSelection && (
          <Filters
            priceRangeInitial={priceRangeInitial}
            priceRangeCurrent={priceRangeCurrent}
            setPriceRangeCallback={setPriceRangeCurrent}
          />
        )}

        {automaticTicketSelection ? (
          <Automatic isGroup={false} priceRangeCurrent={priceRangeCurrent} ticketsData={ticketsData} />
        ) : (
          <TicketSeatSelector
            eventId={eventTicket.eventId}
            id="checkout"
            map={eventTicket.map as IMap}
            modalRef={modalRef}
            onSeatSelect={onSelectSeat}
            persistSelectSeat={true}
            fromCollection={Boolean(typeTicketCollection)}
          />
        )}
      </div>
    </GridColumn>
  )
}

export default Single
